// Translations for the application
export const translations = {
  pl: {
    // Header
    language: 'PL',
    
    // Hero Section
    heroTitle: 'Opisy urządzeń Buglo',
    heroSubtitle: 'Przygotowujesz przetarg lub ofertę dla produktów Buglo?',
    heroDescription1: 'Zyskaj przewagę i pobierz',
    heroDescription2: 'kompletne, profesjonalne',
    heroDescription3: 'opisy produktów Buglo',
    heroDescription4: '– gotowe do użycia w dokumentacji!',
    
    // Form Section
    formTitle: 'Pobierz teraz i przyspiesz przygotowanie swojej oferty!',
    selectProducts: 'Wybierz produkty',
    selectLanguage: 'Wybierz język',
    searchPlaceholder: 'Wyszukaj i wybierz produkty...',
    languagePlaceholder: 'Wybierz język...',
    downloadButton: 'Pobierz',
    loadingButton: 'Pobierz',
    
    // Results Section
    resultsTitle: 'Opisy urządzeń Buglo',
    copyButton: 'Kopiuj',
    copiedButton: 'Skopiowano!',
    expandText: 'Rozwiń',
    collapseText: 'Zwiń',
    
    // PDF Section
    pdfTitle: 'Pobierz plik PDF ze wszystkimi opisami',
    pdfButton: 'Pobierz',
    pdfGenerating: 'Pobierz',
    
    // Navigation
    backToForm: 'Powrót do formularza',
    
    // Footer
    footerTitle: 'Masz pytania?',
    footerContact: 'Skontaktuj się z nami:',
    footerCopyright: 'Wszelkie prawa zastrzeżone',
    footerCreated: 'Created by slawinsky.pl',
    
    // Messages
    noDescription: 'Brak opisu dla tego języka',
    noData: 'Brak Danych',
    noDataMessage: 'Nie znaleziono danych o opisach produktów.',
    backToFormButton: 'Powrót do Formularza',
    noProducts: 'Nie znaleziono produktów dla',
    noProductsAvailable: 'Brak produktów',
    noLanguages: 'Brak dostępnych języków',
    loading: 'Ładowanie...',
    error: 'Wystąpił błąd podczas generowania PDF. Spróbuj ponownie.',
    
    // PDF Content Translations
    pdfContentTitle: 'Opisy Produktów',
    pdfLanguageLabel: 'Język',
    pdfGeneratedLabel: 'Wygenerowano',
    pdfProductsCountLabel: 'Liczba produktów',
    pdfLanguageDescLabel: 'Język opisów',
    pdfGenerationDateLabel: 'Data generowania',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Seria',
    pdfProductPositionLabel: 'Pozycja',
    pdfNoDescriptionMessage: 'Brak opisu dla tego produktu',
    pdfFooterGenerated: 'Dokument wygenerowany automatycznie przez system Buglo Products',
    pdfFooterTotal: 'Łącznie produktów',
    pdfFooterDate: 'Data'
  },
  
  en: {
    // Header
    language: 'EN',
    
    // Hero Section
    heroTitle: 'Buglo Equipment Descriptions',
    heroSubtitle: 'Are you preparing a tender or offer for Buglo products?',
    heroDescription1: 'Gain an advantage and download',
    heroDescription2: 'complete, professional',
    heroDescription3: 'Buglo product descriptions',
    heroDescription4: '– ready to use in documentation!',
    
    // Form Section
    formTitle: 'Download now and speed up your offer preparation!',
    selectProducts: 'Select products',
    selectLanguage: 'Select language',
    searchPlaceholder: 'Search and select products...',
    languagePlaceholder: 'Select language...',
    downloadButton: 'Download',
    loadingButton: 'Download',
    
    // Results Section
    resultsTitle: 'Buglo Equipment Descriptions',
    copyButton: 'Copy',
    copiedButton: 'Copied!',
    expandText: 'Expand',
    collapseText: 'Collapse',
    
    // PDF Section
    pdfTitle: 'Download PDF file with all descriptions',
    pdfButton: 'Download',
    pdfGenerating: 'Download',
    
    // Navigation
    backToForm: 'Back to form',
    
    // Footer
    footerTitle: 'Have questions?',
    footerContact: 'Contact us:',
    footerCopyright: '© Buglo.pl - All rights reserved',
    footerCreated: 'Created by slawinsky.pl',
    
    // Messages
    noDescription: 'No description available for this language',
    noData: 'No Data',
    noDataMessage: 'No product description data found.',
    backToFormButton: 'Back to Form',
    noProducts: 'No products found for',
    noProductsAvailable: 'No products available',
    noLanguages: 'No languages available',
    loading: 'Loading...',
    error: 'An error occurred while generating PDF. Please try again.',
    
    // PDF Content Translations
    pdfContentTitle: 'Product Descriptions',
    pdfLanguageLabel: 'Language',
    pdfGeneratedLabel: 'Generated',
    pdfProductsCountLabel: 'Number of products',
    pdfLanguageDescLabel: 'Description language',
    pdfGenerationDateLabel: 'Generation date',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Series',
    pdfProductPositionLabel: 'Position',
    pdfNoDescriptionMessage: 'No description available for this product',
    pdfFooterGenerated: 'Document automatically generated by Buglo Products system',
    pdfFooterTotal: 'Total products',
    pdfFooterDate: 'Date'
  },
  
  de: {
    // Header
    language: 'DE',
    
    // Hero Section
    heroTitle: 'Buglo Gerätebeschreibungen',
    heroSubtitle: 'Bereiten Sie eine Ausschreibung oder ein Angebot für Buglo-Produkte vor?',
    heroDescription1: 'Verschaffen Sie sich einen Vorteil und laden Sie',
    heroDescription2: 'vollständige, professionelle',
    heroDescription3: 'Buglo-Produktbeschreibungen',
    heroDescription4: '– bereit für die Verwendung in der Dokumentation!',
    
    // Form Section
    formTitle: 'Jetzt herunterladen und die Angebotserstellung beschleunigen!',
    selectProducts: 'Produkte auswählen',
    selectLanguage: 'Sprache auswählen',
    searchPlaceholder: 'Produkte suchen und auswählen...',
    languagePlaceholder: 'Sprache auswählen...',
    downloadButton: 'Herunterladen →',
    loadingButton: 'Herunterladen',
    
    // Results Section
    resultsTitle: 'Buglo Gerätebeschreibungen',
    copyButton: 'Kopieren →',
    copiedButton: '✅ Kopiert!',
    expandText: 'Erweitern →',
    collapseText: '← Reduzieren',
    
    // PDF Section
    pdfTitle: 'PDF-Datei mit allen Beschreibungen herunterladen',
    pdfButton: 'Herunterladen →',
    pdfGenerating: 'Herunterladen →',
    
    // Navigation
    backToForm: 'Zurück zum Formular',
    
    // Footer
    footerTitle: 'Haben Sie Fragen?',
    footerContact: 'Kontaktieren Sie uns:',
    footerCopyright: '© Buglo.pl - Alle Rechte vorbehalten',
    footerCreated: 'Erstellt von sławinski.pl',
    
    // Messages
    noDescription: 'Keine Beschreibung für diese Sprache verfügbar',
    noData: 'Keine Daten',
    noDataMessage: 'Keine Produktbeschreibungsdaten gefunden.',
    backToFormButton: 'Zurück zum Formular',
    noProducts: 'Keine Produkte gefunden für',
    noProductsAvailable: 'Keine Produkte verfügbar',
    noLanguages: 'Keine Sprachen verfügbar',
    loading: 'Laden...',
    error: 'Beim Generieren der PDF ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    
    // PDF Content Translations
    pdfContentTitle: 'Produktbeschreibungen',
    pdfLanguageLabel: 'Sprache',
    pdfGeneratedLabel: 'Generiert',
    pdfProductsCountLabel: 'Anzahl der Produkte',
    pdfLanguageDescLabel: 'Beschreibungssprache',
    pdfGenerationDateLabel: 'Generierungsdatum',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Serie',
    pdfProductPositionLabel: 'Position',
    pdfNoDescriptionMessage: 'Keine Beschreibung für dieses Produkt verfügbar',
    pdfFooterGenerated: 'Dokument automatisch generiert vom Buglo Products System',
    pdfFooterTotal: 'Gesamtprodukte',
    pdfFooterDate: 'Datum'
  },
  es: {
    language: 'ES',
    heroTitle: 'Descripciones de productos Buglo',
    heroSubtitle: '¿Está preparando una licitación u oferta para productos Buglo?',
    heroDescription1: 'Obtenga ventaja y descargue',
    heroDescription2: 'completas y profesionales',
    heroDescription3: 'descripciones de productos Buglo',
    heroDescription4: '– listas para usar en la documentación!',
    formTitle: '¡Descargue ahora y agilice la preparación de su oferta!',
    selectProducts: 'Seleccionar productos',
    selectLanguage: 'Seleccionar idioma',
    searchPlaceholder: 'Busque y seleccione productos...',
    languagePlaceholder: 'Seleccione idioma...',
    downloadButton: 'Descargar',
    loadingButton: 'Descargando...',
    resultsTitle: 'Descripciones de productos Buglo',
    copyButton: 'Copiar',
    copiedButton: '¡Copiado!',
    expandText: 'Mostrar más',
    collapseText: 'Mostrar menos',
    pdfTitle: 'Descargar PDF con todas las descripciones',
    pdfButton: 'Descargar',
    pdfGenerating: 'Generando...',
    backToForm: 'Volver al formulario',
    footerTitle: '¿Tiene preguntas?',
    footerContact: 'Contáctenos:',
    footerCopyright: '© Buglo.pl - Todos los derechos reservados',
    footerCreated: 'Creado por slawinsky.pl',
    noDescription: 'No hay descripción disponible para este idioma',
    noData: 'Sin datos',
    noDataMessage: 'No se encontraron datos de descripciones de productos.',
    backToFormButton: 'Volver al formulario',
    noProducts: 'No se encontraron productos para',
    noProductsAvailable: 'No hay productos disponibles',
    noLanguages: 'No hay idiomas disponibles',
    loading: 'Cargando...',
    error: 'Se ha producido un error al generar el PDF. Inténtelo de nuevo.',
    pdfContentTitle: 'Descripciones de productos',
    pdfLanguageLabel: 'Idioma',
    pdfGeneratedLabel: 'Generado',
    pdfProductsCountLabel: 'Número de productos',
    pdfLanguageDescLabel: 'Idioma de las descripciones',
    pdfGenerationDateLabel: 'Fecha de generación',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Serie',
    pdfProductPositionLabel: 'Posición',
    pdfNoDescriptionMessage: 'No hay descripción disponible para este producto',
    pdfFooterGenerated: 'Documento generado automáticamente por el sistema Buglo Products',
    pdfFooterTotal: 'Total de productos',
    pdfFooterDate: 'Fecha'
  },
  fr: {
    language: 'FR',
    heroTitle: 'Descriptions des produits Buglo',
    heroSubtitle: 'Préparez-vous un appel d’offres ou une offre pour les produits Buglo ?',
    heroDescription1: 'Gagnez en efficacité et téléchargez',
    heroDescription2: 'des descriptions complètes et professionnelles',
    heroDescription3: 'des produits Buglo',
    heroDescription4: '– prêtes à l’emploi pour votre documentation !',
    formTitle: 'Téléchargez maintenant et accélérez la préparation de votre offre !',
    selectProducts: 'Sélectionner des produits',
    selectLanguage: 'Sélectionner une langue',
    searchPlaceholder: 'Recherchez et sélectionnez des produits...',
    languagePlaceholder: 'Sélectionner une langue...',
    downloadButton: 'Télécharger',
    loadingButton: 'Téléchargement...',
    resultsTitle: 'Descriptions des produits Buglo',
    copyButton: 'Copier',
    copiedButton: 'Copié !',
    expandText: 'Afficher plus',
    collapseText: 'Afficher moins',
    pdfTitle: 'Télécharger le PDF avec toutes les descriptions',
    pdfButton: 'Télécharger',
    pdfGenerating: 'Génération...',
    backToForm: 'Retour au formulaire',
    footerTitle: 'Des questions ?',
    footerContact: 'Contactez-nous :',
    footerCopyright: '© Buglo.pl - Tous droits réservés',
    footerCreated: 'Créé par slawinsky.pl',
    noDescription: 'Aucune description disponible pour cette langue',
    noData: 'Aucune donnée',
    noDataMessage: 'Aucune donnée de description de produit trouvée.',
    backToFormButton: 'Retour au formulaire',
    noProducts: 'Aucun produit trouvé pour',
    noProductsAvailable: 'Aucun produit disponible',
    noLanguages: 'Aucune langue disponible',
    loading: 'Chargement...',
    error: 'Une erreur est survenue lors de la génération du PDF. Veuillez réessayer.',
    pdfContentTitle: 'Descriptions des produits',
    pdfLanguageLabel: 'Langue',
    pdfGeneratedLabel: 'Généré',
    pdfProductsCountLabel: 'Nombre de produits',
    pdfLanguageDescLabel: 'Langue des descriptions',
    pdfGenerationDateLabel: 'Date de génération',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Série',
    pdfProductPositionLabel: 'Position',
    pdfNoDescriptionMessage: 'Aucune description disponible pour ce produit',
    pdfFooterGenerated: 'Document généré automatiquement par le système Buglo Products',
    pdfFooterTotal: 'Nombre total de produits',
    pdfFooterDate: 'Date'
  },
  it: {
    language: 'IT',
    heroTitle: 'Descrizioni dei prodotti Buglo',
    heroSubtitle: 'Stai preparando una gara o un’offerta per i prodotti Buglo?',
    heroDescription1: 'Ottieni un vantaggio e scarica',
    heroDescription2: 'descrizioni complete e professionali',
    heroDescription3: 'dei prodotti Buglo',
    heroDescription4: '– pronte all’uso nella documentazione!',
    formTitle: 'Scarica ora e velocizza la preparazione della tua offerta!',
    selectProducts: 'Seleziona prodotti',
    selectLanguage: 'Seleziona lingua',
    searchPlaceholder: 'Cerca e seleziona i prodotti...',
    languagePlaceholder: 'Seleziona lingua...',
    downloadButton: 'Scarica',
    loadingButton: 'Scaricamento...',
    resultsTitle: 'Descrizioni dei prodotti Buglo',
    copyButton: 'Copia',
    copiedButton: 'Copiato!',
    expandText: 'Mostra di più',
    collapseText: 'Mostra di meno',
    pdfTitle: 'Scarica il PDF con tutte le descrizioni',
    pdfButton: 'Scarica',
    pdfGenerating: 'Generazione...',
    backToForm: 'Torna al modulo',
    footerTitle: 'Domande?',
    footerContact: 'Contattaci:',
    footerCopyright: '© Buglo.pl - Tutti i diritti riservati',
    footerCreated: 'Creato da slawinsky.pl',
    noDescription: 'Nessuna descrizione disponibile per questa lingua',
    noData: 'Nessun dato',
    noDataMessage: 'Nessun dato di descrizione del prodotto trovato.',
    backToFormButton: 'Torna al modulo',
    noProducts: 'Nessun prodotto trovato per',
    noProductsAvailable: 'Nessun prodotto disponibile',
    noLanguages: 'Nessuna lingua disponibile',
    loading: 'Caricamento...',
    error: 'Si è verificato un errore durante la generazione del PDF. Riprova.',
    pdfContentTitle: 'Descrizioni dei prodotti',
    pdfLanguageLabel: 'Lingua',
    pdfGeneratedLabel: 'Generato',
    pdfProductsCountLabel: 'Numero di prodotti',
    pdfLanguageDescLabel: 'Lingua delle descrizioni',
    pdfGenerationDateLabel: 'Data di generazione',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Serie',
    pdfProductPositionLabel: 'Posizione',
    pdfNoDescriptionMessage: 'Nessuna descrizione disponibile per questo prodotto',
    pdfFooterGenerated: 'Documento generato automaticamente dal sistema Buglo Products',
    pdfFooterTotal: 'Totale prodotti',
    pdfFooterDate: 'Data'
  },
  fi: {
    language: 'FI',
    heroTitle: 'Buglo-tuotekuvaukset',
    heroSubtitle: 'Valmisteletko tarjouspyyntöä tai tarjousta Buglo-tuotteista?',
    heroDescription1: 'Saat etua ja lataa',
    heroDescription2: 'täydelliset, ammattimaiset',
    heroDescription3: 'Buglo-tuotekuvaukset',
    heroDescription4: '– valmiina dokumentaatioon!',
    formTitle: 'Lataa nyt ja nopeuta tarjouksen valmistelua!',
    selectProducts: 'Valitse tuotteet',
    selectLanguage: 'Valitse kieli',
    searchPlaceholder: 'Hae ja valitse tuotteita...',
    languagePlaceholder: 'Valitse kieli...',
    downloadButton: 'Lataa',
    loadingButton: 'Ladataan...',
    resultsTitle: 'Buglo-tuotekuvaukset',
    copyButton: 'Kopioi',
    copiedButton: 'Kopioitu!',
    expandText: 'Näytä enemmän',
    collapseText: 'Näytä vähemmän',
    pdfTitle: 'Lataa PDF kaikilla kuvauksilla',
    pdfButton: 'Lataa',
    pdfGenerating: 'Luodaan...',
    backToForm: 'Takaisin lomakkeeseen',
    footerTitle: 'Kysyttävää?',
    footerContact: 'Ota yhteyttä:',
    footerCopyright: '© Buglo.pl – Kaikki oikeudet pidätetään',
    footerCreated: 'Luonut slawinsky.pl',
    noDescription: 'Tälle kielelle ei ole kuvausta',
    noData: 'Ei tietoja',
    noDataMessage: 'Tuotekuvaustietoja ei löytynyt.',
    backToFormButton: 'Takaisin lomakkeeseen',
    noProducts: 'Tuotteita ei löytynyt',
    noProductsAvailable: 'Ei tuotteita saatavilla',
    noLanguages: 'Ei kieliä saatavilla',
    loading: 'Ladataan...',
    error: 'PDF:n luonnissa tapahtui virhe. Yritä uudelleen.',
    pdfContentTitle: 'Tuotekuvaukset',
    pdfLanguageLabel: 'Kieli',
    pdfGeneratedLabel: 'Luotu',
    pdfProductsCountLabel: 'Tuotteiden määrä',
    pdfLanguageDescLabel: 'Kuvausten kieli',
    pdfGenerationDateLabel: 'Luontipäivä',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Sarja',
    pdfProductPositionLabel: 'Sijainti',
    pdfNoDescriptionMessage: 'Tälle tuotteelle ei ole kuvausta',
    pdfFooterGenerated: 'Asiakirja luotu automaattisesti Buglo Products -järjestelmällä',
    pdfFooterTotal: 'Tuotteita yhteensä',
    pdfFooterDate: 'Päivä'
  },
  lv: {
    language: 'LV',
    heroTitle: 'Buglo produktu apraksti',
    heroSubtitle: 'Vai gatavojat iepirkumu vai piedāvājumu Buglo produktiem?',
    heroDescription1: 'Iegūstiet priekšrocības un lejupielādējiet',
    heroDescription2: 'pilnīgus, profesionālus',
    heroDescription3: 'Buglo produktu aprakstus',
    heroDescription4: '– gatavus izmantošanai dokumentācijā!',
    formTitle: 'Lejupielādējiet tagad un paātriniet piedāvājuma sagatavošanu!',
    selectProducts: 'Izvēlieties produktus',
    selectLanguage: 'Izvēlieties valodu',
    searchPlaceholder: 'Meklējiet un izvēlieties produktus...',
    languagePlaceholder: 'Izvēlieties valodu...',
    downloadButton: 'Lejupielādēt',
    loadingButton: 'Lejupielādē...',
    resultsTitle: 'Buglo produktu apraksti',
    copyButton: 'Kopēt',
    copiedButton: 'Nokopēts!',
    expandText: 'Rādīt vairāk',
    collapseText: 'Rādīt mazāk',
    pdfTitle: 'Lejupielādēt PDF ar visiem aprakstiem',
    pdfButton: 'Lejupielādēt',
    pdfGenerating: 'Ģenerē...',
    backToForm: 'Atpakaļ uz formu',
    footerTitle: 'Jautājumi?',
    footerContact: 'Sazinieties ar mums:',
    footerCopyright: '© Buglo.pl - Visas tiesības aizsargātas',
    footerCreated: 'Izveidoja slawinsky.pl',
    noDescription: 'Šai valodai nav pieejama apraksta',
    noData: 'Nav datu',
    noDataMessage: 'Nav atrasti produktu apraksti.',
    backToFormButton: 'Atpakaļ uz formu',
    noProducts: 'Netika atrasti produkti',
    noProductsAvailable: 'Nav pieejamu produktu',
    noLanguages: 'Nav pieejamu valodu',
    loading: 'Ielādē...',
    error: 'Radās kļūda, ģenerējot PDF. Lūdzu, mēģiniet vēlreiz.',
    pdfContentTitle: 'Produktu apraksti',
    pdfLanguageLabel: 'Valoda',
    pdfGeneratedLabel: 'Ģenerēts',
    pdfProductsCountLabel: 'Produktu skaits',
    pdfLanguageDescLabel: 'Aprakstu valoda',
    pdfGenerationDateLabel: 'Ģenerēšanas datums',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Sērija',
    pdfProductPositionLabel: 'Pozīcija',
    pdfNoDescriptionMessage: 'Šim produktam nav pieejams apraksts',
    pdfFooterGenerated: 'Dokuments automātiski ģenerēts ar Buglo Products sistēmu',
    pdfFooterTotal: 'Produktu kopskaits',
    pdfFooterDate: 'Datums'
  },
  et: {
    language: 'ET',
    heroTitle: 'Buglo toodete kirjeldused',
    heroSubtitle: 'Kas valmistate ette Buglo toodete hanget või pakkumist?',
    heroDescription1: 'Saage eelis ja laadige alla',
    heroDescription2: 'täielikud ja professionaalsed',
    heroDescription3: 'Buglo toodete kirjeldused',
    heroDescription4: '– valmis kasutamiseks dokumentatsioonis!',
    formTitle: 'Laadige kohe alla ja kiirendage pakkumise ettevalmistust!',
    selectProducts: 'Vali tooted',
    selectLanguage: 'Vali keel',
    searchPlaceholder: 'Otsi ja vali tooteid...',
    languagePlaceholder: 'Vali keel...',
    downloadButton: 'Laadi alla',
    loadingButton: 'Laen...',
    resultsTitle: 'Buglo toodete kirjeldused',
    copyButton: 'Kopeeri',
    copiedButton: 'Kopeeritud!',
    expandText: 'Näita rohkem',
    collapseText: 'Näita vähem',
    pdfTitle: 'Laadi alla PDF kõigi kirjeldustega',
    pdfButton: 'Laadi alla',
    pdfGenerating: 'Genereerin...',
    backToForm: 'Tagasi vormi juurde',
    footerTitle: 'Küsimusi?',
    footerContact: 'Võtke meiega ühendust:',
    footerCopyright: '© Buglo.pl – Kõik õigused kaitstud',
    footerCreated: 'Loonud slawinsky.pl',
    noDescription: 'Sellele keelele pole kirjeldust',
    noData: 'Andmed puuduvad',
    noDataMessage: 'Tootekirjelduste andmeid ei leitud.',
    backToFormButton: 'Tagasi vormi juurde',
    noProducts: 'Tooteid ei leitud',
    noProductsAvailable: 'Tooteid pole saadaval',
    noLanguages: 'Keeli pole saadaval',
    loading: 'Laen...',
    error: 'PDF genereerimisel tekkis viga. Palun proovige uuesti.',
    pdfContentTitle: 'Tootekirjeldused',
    pdfLanguageLabel: 'Keel',
    pdfGeneratedLabel: 'Genereeritud',
    pdfProductsCountLabel: 'Toodete arv',
    pdfLanguageDescLabel: 'Kirjelduste keel',
    pdfGenerationDateLabel: 'Genereerimise kuupäev',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Seeria',
    pdfProductPositionLabel: 'Positsioon',
    pdfNoDescriptionMessage: 'Sellel tootel pole kirjeldust',
    pdfFooterGenerated: 'Dokument genereeritud automaatselt Buglo Products süsteemi poolt',
    pdfFooterTotal: 'Tooteid kokku',
    pdfFooterDate: 'Kuupäev'
  },
  lt: {
    language: 'LT',
    heroTitle: 'Buglo produktu aprasymai',
    heroSubtitle: 'Ar rengiate konkursą ar pasiūlymą Buglo produktams?',
    heroDescription1: 'Įgykite pranašumą ir atsisiųskite',
    heroDescription2: 'išsamius ir profesionalius',
    heroDescription3: 'Buglo produktų aprašymus',
    heroDescription4: '– paruoštus naudoti dokumentacijoje!',
    formTitle: 'Atsisiųskite dabar ir paspartinkite pasiūlymo rengimą!',
    selectProducts: 'Pasirinkite produktus',
    selectLanguage: 'Pasirinkite kalbą',
    searchPlaceholder: 'Ieškokite ir pasirinkite produktus...',
    languagePlaceholder: 'Pasirinkite kalbą...',
    downloadButton: 'Atsisiųsti',
    loadingButton: 'Atsisiunčiama...',
    resultsTitle: 'Buglo produktų aprašymai',
    copyButton: 'Kopijuoti',
    copiedButton: 'Nukopijuota!',
    expandText: 'Rodyti daugiau',
    collapseText: 'Rodyti mažiau',
    pdfTitle: 'Atsisiųsti PDF failą su visais aprašymais',
    pdfButton: 'Atsisiųsti',
    pdfGenerating: 'Generuojama...',
    backToForm: 'Grįžti į formą',
    footerTitle: 'Turite klausimų?',
    footerContact: 'Susisiekite su mumis:',
    footerCopyright: '© Buglo.pl - Visos teisės saugomos',
    footerCreated: 'Sukurta slawinsky.pl',
    noDescription: 'Šiai kalbai aprašymo nėra',
    noData: 'Nėra duomenų',
    noDataMessage: 'Nerasta produktų aprašymų duomenų.',
    backToFormButton: 'Grįžti į formą',
    noProducts: 'Produktų nerasta',
    noProductsAvailable: 'Nėra galimų produktų',
    noLanguages: 'Nėra galimų kalbų',
    loading: 'Kraunama...',
    error: 'Generuojant PDF įvyko klaida. Bandykite dar kartą.',
    pdfContentTitle: 'Produktų aprašymai',
    pdfLanguageLabel: 'Kalba',
    pdfGeneratedLabel: 'Sugeneruota',
    pdfProductsCountLabel: 'Produktų skaičius',
    pdfLanguageDescLabel: 'Aprašymų kalba',
    pdfGenerationDateLabel: 'Generavimo data',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Serija',
    pdfProductPositionLabel: 'Pozicija',
    pdfNoDescriptionMessage: 'Šiam produktui aprašymo nėra',
    pdfFooterGenerated: 'Dokumentas automatiškai sugeneruotas Buglo Products sistemos',
    pdfFooterTotal: 'Iš viso produktų',
    pdfFooterDate: 'Data'
  },
  sk: {
    language: 'SK',
    heroTitle: 'Popisy produktov Buglo',
    heroSubtitle: 'Pripravujete verejné obstarávanie alebo ponuku pre produkty Buglo?',
    heroDescription1: 'Získajte výhodu a stiahnite si',
    heroDescription2: 'kompletné a profesionálne',
    heroDescription3: 'popisy produktov Buglo',
    heroDescription4: '– pripravené na použitie v dokumentácii!',
    formTitle: 'Stiahnite si teraz a urýchlite prípravu svojej ponuky!',
    selectProducts: 'Vyberte produkty',
    selectLanguage: 'Vyberte jazyk',
    searchPlaceholder: 'Vyhľadajte a vyberte produkty...',
    languagePlaceholder: 'Vyberte jazyk...',
    downloadButton: 'Stiahnuť',
    loadingButton: 'Načítavam...',
    resultsTitle: 'Popisy produktov Buglo',
    copyButton: 'Kopírovať',
    copiedButton: 'Skopírované!',
    expandText: 'Zobraziť viac',
    collapseText: 'Zobraziť menej',
    pdfTitle: 'Stiahnuť PDF so všetkými popismi',
    pdfButton: 'Stiahnuť',
    pdfGenerating: 'Generujem...',
    backToForm: 'Späť na formulár',
    footerTitle: 'Máte otázky?',
    footerContact: 'Kontaktujte nás:',
    footerCopyright: '© Buglo.pl – Všetky práva vyhradené',
    footerCreated: 'Vytvoril slawinsky.pl',
    noDescription: 'Pre tento jazyk nie je dostupný popis',
    noData: 'Žiadne údaje',
    noDataMessage: 'Nenašli sa žiadne údaje o popisoch produktov.',
    backToFormButton: 'Späť na formulár',
    noProducts: 'Nenašli sa žiadne produkty',
    noProductsAvailable: 'Žiadne produkty k dispozícii',
    noLanguages: 'Žiadne jazyky k dispozícii',
    loading: 'Načítavam...',
    error: 'Pri generovaní PDF došlo k chybe. Skúste to znova.',
    pdfContentTitle: 'Popisy produktov',
    pdfLanguageLabel: 'Jazyk',
    pdfGeneratedLabel: 'Vygenerované',
    pdfProductsCountLabel: 'Počet produktov',
    pdfLanguageDescLabel: 'Jazyk popisov',
    pdfGenerationDateLabel: 'Dátum generovania',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Séria',
    pdfProductPositionLabel: 'Pozícia',
    pdfNoDescriptionMessage: 'Pre tento produkt nie je dostupný popis',
    pdfFooterGenerated: 'Dokument automaticky vygenerovaný systémom Buglo Products',
    pdfFooterTotal: 'Celkom produktov',
    pdfFooterDate: 'Dátum'
  },
  ua: {
    language: 'UA',
    heroTitle: 'Описи обладнання Buglo',
    heroSubtitle: 'Готуєте тендер або пропозицію для продуктів Buglo?',
    heroDescription1: 'Отримайте перевагу та завантажте',
    heroDescription2: 'повні, професійні',
    heroDescription3: 'описи продуктів Buglo',
    heroDescription4: '– готові до використання в документації!',
    formTitle: 'Завантажте зараз і пришвидште підготовку вашої пропозиції!',
    selectProducts: 'Виберіть продукти',
    selectLanguage: 'Виберіть мову',
    searchPlaceholder: 'Шукайте та виберіть продукти...',
    languagePlaceholder: 'Виберіть мову...',
    downloadButton: 'Завантажити',
    loadingButton: 'Завантаження...',
    resultsTitle: 'Описи обладнання Buglo',
    copyButton: 'Копіювати',
    copiedButton: 'Скопійовано!',
    expandText: 'Розгорнути',
    collapseText: 'Згорнути',
    pdfTitle: 'Завантажити PDF-файл з усіма описами',
    pdfButton: 'Завантажити',
    pdfGenerating: 'Генерація...',
    backToForm: 'Повернутися до форми',
    footerTitle: 'Маєте запитання?',
    footerContact: 'Зв\'яжіться з нами:',
    footerCopyright: '© Buglo.pl – Усі права захищено',
    footerCreated: 'Створено slawinsky.pl',
    noDescription: 'Немає опису для цієї мови',
    noData: 'Немає даних',
    noDataMessage: 'Не знайдено даних про описи продуктів.',
    backToFormButton: 'Повернутися до форми',
    noProducts: 'Не знайдено продуктів для',
    noProductsAvailable: 'Немає доступних продуктів',
    noLanguages: 'Немає доступних мов',
    loading: 'Завантаження...',
    error: 'Під час генерації PDF сталася помилка. Спробуйте ще раз.',
    pdfContentTitle: 'Описи продуктів',
    pdfLanguageLabel: 'Мова',
    pdfGeneratedLabel: 'Згенеровано',
    pdfProductsCountLabel: 'Кількість продуктів',
    pdfLanguageDescLabel: 'Мова описів',
    pdfGenerationDateLabel: 'Дата генерації',
    pdfProductIdLabel: 'ID',
    pdfProductSeriesLabel: 'Серія',
    pdfProductPositionLabel: 'Позиція',
    pdfNoDescriptionMessage: 'Немає опису для цього продукту',
    pdfFooterGenerated: 'Документ автоматично згенеровано системою Buglo Products',
    pdfFooterTotal: 'Всього продуктів',
    pdfFooterDate: 'Дата'
  }
};

export type LanguageCode = keyof typeof translations;

export const getTranslation = (key: string, language: LanguageCode = 'pl'): string => {
  const keys = key.split('.');
  let value: any = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
